import React from 'react';
import { useAuth } from '../hooks/useAuth';
import Navbar from '../components/Navbar';
import WebSocketDemo from '../components/WebSocketDemo';

const WebSocketPage: React.FC = () => {
  const { user } = useAuth();

  return (
    <div className="min-h-screen bg-gray-50">
      <Navbar />

      <div className="max-w-7xl mx-auto py-6 sm:px-6 lg:px-8">
        <div className="px-4 py-6 sm:px-0">
          <div className="mb-8">
            <h1 className="text-3xl font-bold text-gray-900">WebSocket Live Feed</h1>
            <p className="mt-2 text-sm text-gray-600">
              Real-time communication with the server using WebSockets. Welcome,{' '}
              <span className="font-medium">{user?.username}</span>!
            </p>
          </div>

          <WebSocketDemo />
        </div>
      </div>
    </div>
  );
};

export default WebSocketPage;
